import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { FormattedMessage } from '@flipster/i18n';

import { convertModalBunja } from './state';

export const Header = () => {
  const {
    steps: { currentStepAtom },
  } = useBunja(convertModalBunja);
  const { step } = useAtomValue(currentStepAtom);

  if (step === 'complete') return null;
  if (step === 'preview') {
    return (
      <h2>
        <FormattedMessage id='Convert.r250401.Confirm_your_conversion' />
      </h2>
    );
  }
  return (
    <h2>
      <FormattedMessage id='Convert.r250401.Currency_conversion' />
    </h2>
  );
};
